module.exports = __webpack_public_path__ + "static/ReelDrama-7d23f146aac18c03b7449411c07547d2.png";